import React ,{useEffect} from 'react'
import '../Css/Readmore.css';
import dummy from '../Components/image/dummy.png'
export default function Happyclient(props) {
    useEffect((()=>
  {
    document.title ='Client';
  }))
  return (
    <div >
    <div id='recive'>
     Id:{props.id}
     <br/>
     Name:{props.name}
     <br/>
     Phone:{props.phone}
     <br/>
     Email:{props.email}
     <br/> 
     <img src={dummy} alt='client_picture' id='profile'></img>   
    </div> 
    </div>
  )
}
